# JiffyWorks Framework Site JS
#
# Author: Pete Larson <plarson@jiffymedia.com>
# Version: 1.8.5
# Last Modified: 1.22.2015

window.debug_enabled = false
window.send_scroll_complete = false

window.defaults =
  globalJQEasing: 'easeOutCubic'
  mobileWidth: 640
  iPadWidth: 768

$ = jQuery

# Utility Framework Functions
window.debug = (message, level = "debug") ->
  if window.debug_enabled and console? and console.log?
    if message is null
      console.warn "null"
    else
      switch level
        when "warn"
          console.warn message
        when "error"
          console.error message
        when "info"
          console.info message
        when "table"
          if console.table
            console.table message
          else
            console.log message
        when "dump"
          if console.dir
            console.dir message
          else
            console.log message
        else
          console.log message

debug = window.debug

window.puts = (message, level = "debug") ->
  window.debug(message, level)

window.register = (eventName, namespace, handler, listenObj = jQuery(window)) ->
  listenObj.on(eventName+'.'+namespace, handler)

window.destroy = (namespace, destroyObj = jQuery.Window) ->
  destroyObj.off('.'+namespace)

window.trigger = (eventName, data, triggerObj = jQuery.Window) ->
  window.announce eventName, data, triggerObj

window.announce = (eventName, data, triggerObj = jQuery.Window) ->
  if data? then triggerObj.triggerHandler(eventName, data) else triggerObj.triggerHandler(eventName)

window.respond_to = (event_name, handler, listen_obj = jQuery.Window) ->
  listen_obj.on(event_name, handler)

window.stop_responding_to = (event_name, handler, listen_obj = jQuery.Window) ->
  listen_obj.off(event_name, handler)

window.px = (css_pixel_value) ->
  try
    return parseFloat(css_pixel_value) + "px"
  catch error
    return css_pixel_value

# Define the events namespace which is "_a"
window._a =
  ESC_PRESS: 'keyEscape'
  ENTER_KEY_PRESS: 'keyEnter'
  ENTER_KEY_PRESSED: 'keyEnter'
  SPACE_KEY_PRESS: 'keySpace'
  SPACE_KEY_PRESSED: 'keySpace'
  UP_KEY_PRESS: 'keyUp'
  UP_KEY_PRESSED: 'keyUp'
  DOWN_KEY_PRESS: 'keyDown'
  DOWN_KEY_PRESSED: 'keyDown'
  RIGHT_KEY_PRESS: 'keyRight'
  RIGHT_KEY_PRESSED: 'keyRight'
  LEFT_KEY_PRESS: 'keyLeft'
  LEFT_KEY_PRESSED: 'keyLeft'
  RESIZE: 'resizeSite'
  RESIZED: 'resizeSite'
  RESIZE_COMPLETION: 'resizeSiteComplete'
  RESIZE_COMPLETED: 'resizeSiteComplete'
  SCROLL_COMPLETION: 'scrollComplete'
  SCROLL_COMPLETED: 'scrollComplete'
  CLICK: 'click'
  CLICKED: 'click'
  TOUCH_START: 'touchstart'
  TOUCH_STARTED: 'touchstart'
  TOUCH_MOVE: "touchmove"
  TOUCH_MOVED: "touchmove"
  TOUCH_END: "touchend"
  TOUCH_ENDED: "touchend"
  CHANGE: 'change'
  CHANGED: 'change'
  SUBMIT: 'submit'
  SUBMITED: 'submit'
  FOCUS: 'focus'
  FOCUSED: 'focus'
  BLUR: 'blur'
  BLURED: 'blur'
  MOUSE_OVER: 'mouseover'
  MOUSED_OVER: 'mouseover'
  MOUSE_OUT: 'mouseout'
  MOUSED_OUT: 'mouseout'
  MOUSE_ENTER: 'mouseenter'
  MOUSED_ENTER: 'mouseenter'
  MOUSE_LEAVE: 'mouseleave'
  MOUSE_LEFT: 'mouseleave'
  MOUSE_DOWN: 'mousedown'
  MOUSED_DOWN: 'mousedown'
  MOUSE_UP: 'mouseup'
  MOUSED_UP: 'mouseup'
  SCROLL: 'scroll'
  SCROLLED: 'scroll'
  SHOWN: 'shown'
  SHOW: 'show'
  HIDE: 'hide'
  HIDDEN: 'hidden'
  INSTANTIATED_FRAMEWORK: 'frameworkInstantiated'
  WIDTH_FORMAT_CHANGE: "width_format_change"
  WIDTH_FORMAT_CHANGED: "width_format_change"
  INITIALIZE_DATASCRIPTS: "initialize_datascripts"
  DATASCRIPTS_INITIALIZED: "initialize_datascripts"
  SHOW_MESSAGE: 'show_message'
  MESSAGE_SHOWN: 'show_message'
  VALIDATE_FORM: 'validate_form'
  FORM_VALIDATED: 'validate_form'
  VALID_FORM: 'form_is_valid'
  IMAGES_LOADED: 'images_loaded'
  OPEN_OVERLAY: 'open_overlay'

# Map the new events collection to the legacy namespace
$.Events = window._a

if TweenLite?
  defaults.globalEasing = Cubic.easeOut

$.Body = $('body')
if $(window)
  $.Window = $(window)
else
  $.Window = $(document)
# if ($.browser.mozilla? or $.browser.msie?) then $.Scroll = $('html') else $.Scroll = $.Body
$.Scroll = $.Body

$.MobileWebkit = ($.Body.hasClass('webkit-mobile') or (navigator.userAgent.match(/iPhone/i)) or (navigator.userAgent.match(/iPod/i)) or (navigator.userAgent.match(/iPad/i)))
$.MobileDevice = ((navigator.userAgent.match(/iPhone/i)) or (navigator.userAgent.match(/iPod/i)) or (navigator.userAgent.match(/Android/i)))
$.Tablet = ((navigator.userAgent.match(/iPad/i)))

$.MobileSize = false
$.TabletSize = false

$.Messages =
  FILL_IN_ALL_REQUIRED_FIELDS: "Please fill in all required fields"

$ ->
  #shortcut to setting the id of an element
  $.fn.id = (element_id) ->
    if element_id? then $(this).attr("id", element_id)
    return $(this).attr("id")

  #You can use the data-script attribute to instantiate an object
  #  If you want multiple objects on the same html element, you can separate
  #  the controller names by commas
  $.fn.Instantiate = (settings) ->
    config = settings

    this.each (index) ->
      $me = $(this)
      _instantiateController = (controller_name) ->
        if $me[controller_name]?
          $me[controller_name](controller_name, config)
        else
          debug "Couldn't find controller: " + controller_name


      controller_names = $me.data("script").split(",")
      _instantiateController controller_name for controller_name in controller_names

  $.fn.Framework = (name, defaults) ->
    #Initialize
    config =
        myName: name
      if defaults? then jQuery.extend(config, defaults)

    #Private Functions
    _scrollTimeout = null
    _init = () ->
      register(_a.INITIALIZE_DATASCRIPTS, config.myName, _initializeDataScripts)
      #set up the google analytics class. This call needs to be reworked
      if config.analyticsEnabled then $.Body.GoogleAnalytics()
      _resize()
      # register(_a.SCROLL,name,_scroll)
      $(window).on('resize', _resize)
      # send out the event that the framework has been instantiated
      trigger(_a.INSTANTIATED_FRAMEWORK, defaults)
    _initializeDataScripts = (evt) ->
      #Instantiate any objects with the "data-script" attribute
      if $('[data-script]').size() > 0 then $('[data-script]').Instantiate(defaults)
    _resize = (evt) ->
      try
        $.Window.windowWidth = $.Window.width()
        $.Window.windowHeight = $.Window.height()
        if $.Window.windowWidth < 769
          $.TabletSize = true
        else
          $.TabletSize = false
        if $.Window.windowWidth < 641
          $.MobileSize = true
        else
          $.MobileSize = false
      catch err
        debug "try catch error"
      finally
        # debug("")

      $.Window.trigger(_a.RESIZE)
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(_resizeCallback, 150)

    _resizeCallback = ->
      clearTimeout(@resizeTimer)
      _resizeComplete()

    _resizeComplete = ->
      $.Window.windowWidth = $.Window.width()
      $.Window.windowHeight = $.Window.height()
      $.Window.triggerHandler(_a.RESIZE_COMPLETION)

    _init()

  $.fn.announce = (event_name, data) ->
    debug "announcing"
    if data? then $(this).triggerHandler(event_name, data) else $(this).triggerHandler(event_name)

  $.fn.respond_to = (event_name, handler) ->
    $(this).on(event_name, handler)

  $.fn.SkinnableCheckbox = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      $I = $me = $(this)
      _my_input = $me.find("input[type=checkbox]")

      init_box_state = () ->
        debug "init_box_state"

        if _my_input.prop("checked")
          $me.addClass("checked")

        debug _my_input.prop("checked")

      toggle_the_box = (evt) ->
        debug "toggle the box"

        if _my_input.prop("checked")
          _my_input.prop( "checked", false )
          $me.removeClass("checked")
        else
          _my_input.prop( "checked", true )
          $me.addClass("checked")

        debug _my_input.prop("checked")

      preload_the_images = () ->
        if _unchecked_image
          unchecked_image_obj = new Image()
          unchecked_image_obj.src = _unchecked_image_src

        if _checked_image
          checked_image_obj = new Image()
          checked_image_obj.src = _checked_image_src

      init = () ->
        $I.respond_to _a.CLICK, toggle_the_box
        init_box_state()
        # setTimeout toggle_the_box, 2000
        # setTimeout toggle_the_box, 5000
        # preload_the_images()

      init()

    $.fn.SkinnableRadioButton = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      $I = $me = $(this)
      _my_buttons = $me.find("input[type=radio]")
      _unchecked_image_src = $me.data('unchecked_image')
      _checked_image_src = $me.data('checked_image')

      set_button_state = (button) ->
        if button.checked
          button.addClass("selected")
        else
          button.removeClass("selected")

      select_the_button = (evt) ->
        $me.addClass("selected")
        _my_buttons.each set_button_state

      preload_the_images = () ->
        if _unchecked_image_src
          unchecked_image_obj = new Image()
          unchecked_image_obj.src = _unchecked_image_src

        if _checked_image_src
          checked_image_obj = new Image()
          checked_image_obj.src = _checked_image_src

      init = () ->
        $I.respond_to _a.CLICK, select_the_button
        preload_the_images()

      init()

  $.fn.FormWithRequiredFields = (objectName, @settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if @settings? then jQuery.extend(config, @settings)

    this.each (index) ->
      $me = $(this)
      _required_fields = $me.find("input.required, select.required, textfield.required")
      _a_required_field_is_blank = false

      _init = () ->
        if $me.data('submitonvalid') == true
          register(_a.SUBMIT, config.myName, _on_form_submit, $me)
        else
          register(_a.VALIDATE_FORM, config.myName, _on_form_submit, $me)

        register(_a.BLUR, config.myName, _on_field_blur, _required_fields)
        # register(_a.SUBMIT,config.myName,_on_form_submit,$me)

      _on_field_blur = () ->
        if $(this).val() != ""
          $(this).removeClass("invalid")

      _check_complete = (field) ->
        the_field = $(field)
        if the_field.val() is ""
          _a_required_field_is_blank = true
          the_field.addClass("invalid")

      _on_form_submit = (evt) ->
        if evt then evt.preventDefault()

        _a_required_field_is_blank = false

        _check_complete field for field in _required_fields

        if _a_required_field_is_blank
          trigger(_a.SHOW_MESSAGE, $.Messages.FILL_IN_ALL_REQUIRED_FIELDS)
        else
          if $me.data('submitonvalid')
            $me.get(0).submit()
          else
            trigger(_a.FORM_IS_VALID, null, $me)

      _init()


window.debug_enabled = true

$.CustomEvents =
  SITE_INITIALIZED: "site_initialized"
  TOGGLE_NAV: "toggle_nav"
  OPEN_OVERLAY: "open_overlay"

window.custom_defaults =
  mobileWidth: 480
  iPadWidth: 768
  default_fade_duration: .4
  map_styles: [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#65605e"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#c3c0b5"
            },
            {
                "lightness": "75"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "hue": "#ff0000"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "all",
        "stylers": [
            {
                "hue": "#ff0000"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry",
        "stylers": [
            {
                "hue": "#ff0000"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "all",
        "stylers": [
            {
                "saturation": "0"
            },
            {
                "hue": "#ff0000"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "color": "#847770"
            },
            {
                "lightness": "37"
            },
            {
                "saturation": "-44"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#517591"
            },
            {
                "visibility": "on"
            }
        ]
    }
]

$ ->
  ###*
   * Main controller for the site
   * @param {string} objectName
   * @param {obj} @settings
  ###
  $.fn.Site = (objectName, @settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if @settings? then jQuery.extend(config, @settings)

    this.each (index) ->
      $me = $(this)

      _init = () ->
        register($.Events.RESIZE, config.myName, _resize)
        _resize()
        trigger($.Events.INITIALIZE_DATASCRIPTS)
        trigger($.Events.SITE_INITIALIZED)

        debug("Initiating: " + config.myName)
        debug("Defaults:")
        debug(config)

        # _initialize_plugins()
        # _initialize_skinnable_form_elements()
        respond_to _a.SCROLL, _scrolled

      _scrolled = (evt) ->
        if $.Window.scrollTop() > 200
          $("body").addClass("scrolled")
        else
          $("body").removeClass("scrolled")

      _resize = (evt) ->

      _onImagesLoaded = (instance) ->
        debug "IMAGES HAVE BEEN LOADED"
        announce _a.IMAGES_LOADED

      _initialize_skinnable_form_elements = () ->
        # $(".gfield_checkbox li").SkinnableCheckbox("SkinnableCheckbox")

      _initialize_plugins = () ->
        # if we're not on mobile then disable phone links
        if $("html").hasClass("no-touch")
          $(".phone-link").attr("href", "#").attr("onclick", "return false;")

      _init()

  $.fn.Home = (objectName, @settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if @settings? then jQuery.extend(config, @settings)

    this.each (index) ->
      $me = $(this)

      _init = () ->
        slideUp = {
            distance: '10%',
            origin: 'bottom',
            opacity: 0,
            delay: 300,
            reset: false
        }
        ScrollReveal().reveal('.animate-in', slideUp);

      _init()

  $.fn.HomeServices = (objectName, @settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if @settings? then jQuery.extend(config, @settings)

    this.each (index) ->
      $me = $(this)
      _services_columns = $me.find('.column')

      _init = () ->
        slideUp = {
            distance: '20px',
            origin: 'bottom',
            opacity: 0,
            delay: 200,
            duration: 600,
            # interval: 50,
            # container: '.services',
            # viewOffset: {
            #     top: 0,
            #     right: 0,
            #     bottom: -50,
            #     left: 0,
            # },
            # userDelay: 'once',
            # easing: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
            reset: false
        }
        ScrollReveal().reveal('.services .columns', slideUp);

      _init()

  $.fn.PrimaryNavigation = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      # $I = $me = $(this)
      _navigation_wrapper = $me.find('.cd-navigation-wrapper')
      _isLateralNavAnimating = false

      set_animating_false = () ->
        _isLateralNavAnimating = false

      toggle_navigation = (evt) ->
        evt.preventDefault()
        if not _isLateralNavAnimating
          # if $me.parents(".csstransitions").length > 0 then _isLateralNavAnimating = true
          $('body').toggleClass('navigation-is-open')
          # _navigation_wrapper.one 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', set_animating_false

      init = () ->
        debug "initializing navigation"
        respond_to _a.TOGGLE_NAV, toggle_navigation

      init()

  $.fn.ProjectHeading = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      $I = $me = $(this)
      _my_bg_image = $me.data('image-src')
      _original_height = $me.height()

      adjust_height_by_scroll = (evt) ->
        _scrolltop = $.Window.scrollTop()
        if(_scrolltop > 500)
          return

        # set the new window height
        _my_new_height = $me.height() - _scrolltop + 60
        debug "my height:" + $me.height()
        debug "_my_new_height" + _my_new_height
        if(_my_new_height > 0 && _my_new_height <= _original_height)
          $me.height(_my_new_height)

      init = () ->
        # $me.parallax({imageSrc: _my_bg_image})
        # respond_to _a.SCROLL, adjust_height_ by_scroll

      init()

  $.fn.NavTrigger = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      $I = $me = $(this)

      nav_clicked = (evt) ->
        evt.preventDefault()
        $('body').toggleClass('navigation-is-open')
        announce _a.TOGGLE_NAV

      init = () ->
        debug "initializing trigger"
        $I.respond_to _a.CLICK, nav_clicked

      init()

  $.fn.Slider = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      $I = $me = $(this)
      _autoplay = if $me.data('autoplay') then $me.data('autoplay') else true
      _autoplaySpeed = if $me.data('autoplay-speed') then $me.data('autoplay-speed') else 9000
      _speed = if $me.data('speed') then $me.data('speed') else 2000
      _arrows = $me.data('arrows')
      _fade = $me.data('fade')
      _dots = $me.data('dots')
      _feature_images = $me.find(".feature-image");

      _slider_opts =
        fade: _fade
        autoplay: _autoplay
        autoplaySpeed: 7000
        speed: 700
        arrows: _arrows
        dots: _dots
        adaptiveHeight: false
        pauseOnHover: true
        # cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)'
        respondTo: 'slider'

      show_next_photo = () ->
        $me.slick('slickNext')

      initiate_parallax_photo = () ->
        debug $(this)
        # $(this).parallax({imageSrc: $(this).data('image-src'),speed: 0.1});

      init = () ->
        debug "initializing slider"
        $me.slick(_slider_opts)
        # _feature_images.each initiate_parallax_photo
        # _feature_images.ProjectHeading('ProjectHeading',config)

      init()

  $.fn.Overlay = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      $I = $me = $(this)
      _close_button = $me.find(".close-button")

      overlay_content_loaded = (content) ->
        content_to_append = $(content).find("#main-content")
        $(".overlay .overlay-content").append(content_to_append)
        $(".overlay .overlay-content").find('[data-script]').Instantiate(settings)
        $me.addClass("open")
        $.Body.addClass("open-overlay")

      empty_overlay = () ->
        $(".overlay .overlay-content").empty()

      open_overlay = (evt,load_obj) ->
        evt.preventDefault()
        debug load_obj.target
        debug $me.attr("rel")
        if load_obj.target == $me.attr("rel")
          if(load_obj.el)
            empty_overlay()
            $(".overlay .overlay-content").append(load_obj.el)
            $me.addClass("open")
            $.Body.addClass("open-overlay")
          if(load_obj.url)
            empty_overlay()
            $.get(load_obj.url,overlay_content_loaded)
          else
            $me.addClass("open")

          if load_obj.scrollable
            $me.addClass("scrollable")
          else
            $me.removeClass("scrollable")

      close_overlay = (evt) ->
        evt.preventDefault()
        $me.removeClass("open")
        empty_overlay()
        $.Body.removeClass("open-overlay")

      init = () ->
        respond_to _a.OPEN_OVERLAY, open_overlay
        _close_button.respond_to _a.CLICK, close_overlay
        # $I.respond_to _a.CLICK, close_overlay

      init()

  $.fn.OverlayLink = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      $I = $me = $(this)
      _overlay_target = ""

      open_overlay = (evt) ->
        evt.preventDefault()
        if $me.attr("rel") and $me.attr("rel") != ""
          _overlay_target = $me.attr("rel")
        announce _a.OPEN_OVERLAY, { url:$me.attr("href"),target:_overlay_target }

      init = () ->
        $I.respond_to _a.CLICK, open_overlay

      init()

  $.fn.WorkGrid = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      $I = $me = $(this)

      _grid_opts =
        itemSelector: '.block-item'
        layoutMode: 'masonry'
        masonry: {
          gutter: 30
        }

      init = () ->
        debug index
        slideUp = {
            distance: '14%',
            origin: 'bottom',
            opacity: 0,
            delay: 250,
            interval: 100,
            reset: false
        }
        ScrollReveal().reveal('.block-item', slideUp);
        # $me.imagesLoaded ->
          # $me.isotope(_grid_opts)

      init()

  $.fn.ProjectGrid = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      $I = $me = $(this)

      _grid = null

      _grid_opts = {
        itemSelector: '.block',
        gutter: 30,
        stagger: 30,
        percentPosition: true,
        # horizontal: true
      }

      _make_item_full_size = (evt) ->
        evt.preventDefault()
        debug "make item full size"
        wrapper = $('<div class="full-size-work-wrapper"></div>')
        _full_size_img = $(this).find("img").clone()
        _full_size_img.css("max-width",$(this).data('img-width')+"px")
        wrapper.append(_full_size_img)
        debug "announcing open overlay"
        announce _a.OPEN_OVERLAY, { el:wrapper,target:"",scrollable:true }

      _resize_grid = () ->
        _grid.packery()

      init = () ->
        _grid = $me.packery(_grid_opts)

        $me.imagesLoaded().progress ->
          _grid = _resize_grid()

        if !$('html').hasClass('touch') and $me.hasClass("has-photo")
          $me.find('.block').respond_to(_a.CLICK,_make_item_full_size)

        # slideUp = {
        #     distance: '20px',
        #     origin: 'bottom',
        #     opacity: 0,
        #     delay: 200,
        #     duration: 600,
        #     userDelay: 'once',
        #     easing: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
        #     reset: false
        # }
        # ScrollReveal().reveal('.project-blocks .block', slideUp);

      init()

  $.fn.MasonryBlocks = (objectName, settings) ->
    $parent = $(this)

    if not config? then config = {}
    config.myName = objectName
    if settings? then jQuery.extend(config, settings)

    this.each (index) ->
      $I = $me = $(this)
      _full_size_img = null
      _isotope_opts =
        layoutMode: 'packery',
        itemSelector: '.block',
        percentPosition: true,
        packery: {
          columnWidth: '.block-sizer',
          gutter: '.gutter-sizer'
        }

      _init_isotope = () ->
        $me.isotope(_isotope_opts)

      _relayout = () ->
        $me.isotope 'stamp', $('.stamped')
        $me.isotope 'layout'

      _make_item_full_size = (evt) ->
        evt.preventDefault()
        debug $(this)
        if not $(this).hasClass("has-photo") then return
        wrapper = $('<div class="full-size-work-wrapper"></div>')
        _full_size_img = $(this).find("img").clone()
        _full_size_img.css("max-width",$(this).data('img-width')+"px")
        wrapper.append(_full_size_img)
        announce _a.OPEN_OVERLAY, { el:wrapper,target:"",scrollable:true }

      init = () ->
        $me.imagesLoaded(_init_isotope)
        if !$('html').hasClass('touch')
          $me.find('.block').respond_to(_a.CLICK,_make_item_full_size)

      init()

_docReady = (evt) ->
  if $.CustomEvents?
    jQuery.extend($.Events, $.CustomEvents)

  if $.CustomMessages? then jQuery.extend($.Messages, $.CustomMessages)

  if window.custom_defaults?
    jQuery.extend(window.defaults, window.custom_defaults)

  framework = $('body').Framework("Wigwam", defaults)
  site = $('body').Site("Wigwam", defaults)

$(document).ready(_docReady)
